/*
    // (this is not really working currently)
    @example <button spinner-on-submit> (default class 'spinner-button') or <button spinner-on-submit="loading-class-name">
*/
(function() {

    var spinnerOnSubmit = function() {
        return {
            restrict: "A",
            replace: false,
            transclude: false,
            require: '^form', // parent form binding
            link: function(scope, element, attrs, formCtrl) {

                // set default button class (as it's in a directive name it's never undefined (?) otherwise typeof $scope.spinnerOnSubmit === "undefined"
                var buttonLoadingClass = attrs.spinnerOnSubmit == "" ? 'spinner-button' : attrs.spinnerOnSubmit;

                var formElement = angular.element(element).closest('form');
                formElement.bind("submit", function(event){
                    // if form not invalid or prevent-invalid-submit directive not set
                    if(!formCtrl.$invalid || typeof formElement.attr('prevent-invalid-submit') === "undefined" ) {
                        angular.element(element).addClass(buttonLoadingClass); // add class to the button
                    }
                });

            }

        };
    };
    angular.module('app').directive('spinnerOnSubmit', spinnerOnSubmit);

}());


/**
@ngdoc directive
@name disableOnLoad

@param {Object} disableUrlPatterns array of strings. If provided will only wait for specified urls instead of all xhr calls
@param {string} reRun Not sure this is in use or what it does?

@description
Disables the (submit) button on page load (until there's any pending $http request).<br />
Warning! The directive removes disable="disabled" on init if there's any.

@usage
<button disable-on-load>

*/
(function() {

    var disableOnLoad = function($timeout, $http) {
        return {
            scope: true,
            bindToController: {
                /*  '@' Text binding  '=' Two-way binding  '&' Method binding  '<' One-way binding  */
                disableUrlPatterns: '<?',
                reRun: "=?disableOnLoad",
                timeoutDuration: "="
            },
            controller: function(){
                this.reRun = 0;
            },
            controllerAs: 'ctrl',
            restrict: "A",
            replace: false,
            transclude: false,
            require: 'disableOnLoad', // parent form binding
            link: function(scope, element, attrs, ctrl) {
                // Initiating rerun to be 0, for watch trigger
                ctrl.reRun = 0;

                // watch is done specificly for select all checkbox with large number of ajax loaded records
                // reRun is being incremented by 1 on any xmsListing reload
                if( attrs.disableOnLoad.length ){ // only if there's anything to watch
                    scope.$watch(
                        function(){
                            return ctrl.reRun;
                        },
                        function(newVal, oldVal){
                            if(newVal!==oldVal){
                                disableAndWait();
                            }
                        }
                    );
                }


                var disableAndWait = function(){
                   
                    element.attr("disabled", "disabled");
                    element.children().attr("disabled", "disabled"); // children are for checkboxes (specifically tick-all) and the directive applied on label
                    $timeout(function(){
                        element.attr("disabled", "disabled");
                        element.children().attr("disabled", "disabled"); // children are for checkboxes (specifically tick-all) and the directive applied on label
                        waitForRenderAndDoSomething();
                    });
                };
                disableAndWait();

                /**
                 * Checks if Url contains specific pattern
                 * @param urlToCheck
                 * @returns {boolean}
                 */
                var isUrlToWaitFor = function(urlToCheck){
                    var wait = false;
                    angular.forEach(ctrl.disableUrlPatterns , function(disableUrlPattern){
                        if(!wait)
                            wait = urlToCheck.includes(disableUrlPattern);
                    });
                    //console.log('isUrlToWaitFor',urlToCheck,wait);
                    return wait;
                };

                /**
                 * Wait for all pending request to complete or use a pattern to wait for specific urls
                 */
                var waitForRenderAndDoSomething = function() {
                    // Are there any requests?
                    var waitForPendingRequests = ($http.pendingRequests.length>0);
                    // If we have requests and we have patterns
                    if(waitForPendingRequests && ctrl.disableUrlPatterns){
                        // Assume all urls won't meet patterns until we find one
                        waitForPendingRequests = false;
                        // Find any urls to wait for exit for loop
                        for(var i=0, l=$http.pendingRequests.length; i<l; i++){
                            if(isUrlToWaitFor($http.pendingRequests[i].url)){
                                waitForPendingRequests = true;
                                break;
                            }
                        }
                    }

                    if(waitForPendingRequests) {
                        $timeout(waitForRenderAndDoSomething); // Wait for all templates to be loaded
                    } else {
                        var duration = ctrl.timeoutDuration || 0;
                        $timeout(function(){
                            
                            // maybe it should check if the button have been disabled prior to the directive run and retain the button initial state?
                            element.removeAttr("disabled");
                            element.children().removeAttr("disabled");
                        }, duration);
                    }
                }
            }
        }
    };
    disableOnLoad.$inject = ['$timeout', '$http'];
    angular.module('app').directive('disableOnLoad', disableOnLoad);

}());



/**
@ngdoc directive
@name disableOnSubmit

@description
Disables the (submit) button on form submit.<br />
Warning! The directive removes disable="disabled" on init if there's any.

@usage
<button disable-on-submit>

*/
(function() {

    var disableOnSubmit = function($document) {
        return {
            restrict: "A",
            replace: false,
            transclude: false,
            require: '^form', // parent form binding
            link: function(scope, element, attrs, formCtrl) {

                var formElement = angular.element(element).closest('form');

                var allowInvalidSubmit = false;
                scope.$on('save-invalid-form', function($event){
                    allowInvalidSubmit = true;
                });

                formElement.bind("submit", function(event){
                    // if form not invalid or prevent-invalid-submit directive not set
                    if(!formCtrl.$invalid || allowInvalidSubmit || typeof formElement.attr('prevent-invalid-submit') === "undefined") {
                        allowInvalidSubmit = false;
                        angular.element(element).attr("disabled", "disabled");

                        $document.one('keydown', function(event){
                            var keyCode = event.which || event.keyCode;
                            if(keyCode == 27) { // if ESC key
                                angular.element(element).removeAttr("disabled");
                            }
                        });
                    }
                });

            }

        };
    };
    disableOnSubmit.$inject = ['$document'];
    angular.module('app').directive('disableOnSubmit', disableOnSubmit);

}());


/**
@ngdoc directive
@name allowInvalidSubmit

@description
Sometimes we may want to submit the form which is invalid and we normally wouldn't want to submit (ie. separate Save [save progress] button).

@usage
<button allow-invalid-submit ng-click="saveInvalidForm();">Save</button>

*/
(function() {
    var allowInvalidSubmit = function() {
        return {
            restrict: "A",
            replace: false,
            transclude: false,
            require: '^form', // parent form binding
            link: function(scope, element, attrs, formCtrl) {

                var formElement = angular.element(element).closest('form');
                if( !angular.isDefined(formElement.attr('prevent-invalid-submit')) ){
                    throw "Error: allow-invalid-submit should be used only in conjunction with prevent-invalid-submit on form element.";
                }

                scope.saveInvalidForm = function(){
                    // this gets emitted to prevent-invalid-submit and disable-on-submit directives
                    scope.$emit('save-invalid-form');
                }

            }

        };
    };
    angular.module('app').directive('allowInvalidSubmit', allowInvalidSubmit);
}());